import { Controller } from "@hotwired/stimulus"
import Choices from 'choices.js'

export default class extends Controller {
  static targets = ["choices", "choicesNoSort", "choicesTags", "accountSwitcher"]

  choicesTargetConnected(element) {
    new Choices(element, { searchEnabled: false });
  }

  choicesNoSortTargetConnected(element) {
    new Choices(element, { searchEnabled: false, shouldSort: false });
  }

  choicesTagsTargetConnected(element) {
    new Choices(element, { delimiter: ',', addItems: true, duplicateItemsAllowed: false, editItems: true, removeItemButton: true });
  }

  accountSwitcherTargetConnected(element) {
  new Choices(element, { searchEnabled: true, searchPlaceholderValue: "Search..." });

    element.addEventListener('change', function(e) {
      Turbo.visit(`/account-switcher/choose/${e.target.value}`)
    })
  }
}
